import React, { Component } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import { BrowserRouter as Router, Route } from "react-router-dom";
import Heatmap from './components/HeatMap';
import Header from './components/Header';
import Footer from './components/Footer';
import OdourSurveyFlow from './components/odour-survey-flow/OdourSurveyFlow'
import Help from './components/Help'

const config = {
  firebase: {
    apiKey: "AIzaSyB1ZUCd4QwyGu85yfYi23EBntrXx9JXtfo",
    authDomain: "smelt-it.firebaseapp.com",
    databaseURL: "https://smelt-it.firebaseio.com",
    projectId: "smelt-it",
    storageBucket: "smelt-it.appspot.com",
    messagingSenderId: "817828621626"
  }
};

firebase.initializeApp(config.firebase);

function MapView() {
  return (<div>
    <Header goback></Header>
    <Heatmap></Heatmap>
    <Footer></Footer>
  </div>)
}

function HelpView() {
  return (<div>
    <Header goback></Header>
    <Help></Help>
    <Footer></Footer>
  </div>)
}
class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route path="/" exact component={OdourSurveyFlow} />
          <Route path="/map" component={MapView} />
          <Route path="/help" component={HelpView} />
        </div>
      </Router>
    );
  }
}

export default App;
